var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgListIcon = function SvgListIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14543_633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.11712C7.71337 6.47336 6.78188 6.03153 5.78629 5.82993C5.58453 4.83215 5.1425 3.89889 4.49857 3.11133C3.85658 3.89977 3.41565 4.83275 3.21371 5.82993C2.21812 6.03153 1.28663 6.47336 0.5 7.11712C1.28663 7.76083 2.21812 8.20266 3.21371 8.40426C3.41685 9.39755 3.85778 10.3265 4.49857 11.1113C5.14305 10.3241 5.58523 9.39069 5.78629 8.39273C6.78188 8.19113 7.71337 7.7493 8.5 7.10554",
    fill: "#A6A6A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14543_633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 11,
    fill: "white",
    transform: "translate(0.5 0.111328)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgListIcon);
export default ForwardRef;